import { render, staticRenderFns } from "./LaporanGadaiBaru.vue?vue&type=template&id=31831b15&"
import script from "./LaporanGadaiBaru.vue?vue&type=script&lang=js&"
export * from "./LaporanGadaiBaru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports